import queryString from 'query-string';
import { PayloadValidation, ValidationResponse } from './lib/validation';
import { Utils } from './lib/utils';
import { fnCallback, ConfigurationSettings, DeviceConfiguration } from './controllers/device';
import { RelevantId, RelevantIdResponse } from './controllers/relevantId';

/**
 *
 * @description Temporal Device class to mantain backwards compatibility. Changing to Handler in future releases.
 * @module src/controllers/device but placed outside to be read by rollup.js
 * @version 1.3.0
 **/
export class Device {
  /**
   *
   * @version 1.0.0 Initialize.
   *
   * @version 1.3.0 Main function that will imitate a handler process
   *
   * @since 1.0.0
   * @param {any = {}}   config          Config object.
   * @param {any = fnCallback} successCallback Device service call back.
   * @param {any = fnCallback} errorHandlerCb  Error handler call back.
   */
  public static async init(
    config: DeviceConfiguration,
    successCallback: fnCallback,
    errorHandlerCallback: fnCallback,
  ): Promise<void | string | RelevantIdResponse> {
    // NEML-221 Check for ?skipScript[]=device
    const queryParams = queryString.parse(Utils.getLocationSearch(), {
      arrayFormat: 'bracket',
    });

    if (queryParams.skipScript?.includes('device')) {
      return 'Device rvid call skipped.';
    }

    // Set configuration and merge with default values
    const deviceConfiguration: DeviceConfiguration = new ConfigurationSettings().setPayload(config);

    // Validate that config payload has all requirements
    const validation: ValidationResponse = new PayloadValidation().validatePayload(deviceConfiguration);
    if (!validation.validated) {
      if (typeof errorHandlerCallback !== 'undefined' && errorHandlerCallback !== null) {
        errorHandlerCallback(validation.message);
      }
      return validation.message;
    }

    // NEML-124 Return a promise
    try {
      const relevantIdResponse = await new RelevantId(deviceConfiguration).getRelevantId();

      if (successCallback) {
        successCallback(relevantIdResponse);
      }
      if (deviceConfiguration.useCache) {
        RelevantId.saveRelevantToCache(relevantIdResponse);
      }
      return relevantIdResponse;
    } catch (err) {
      if (errorHandlerCallback) {
        errorHandlerCallback(err.message);
      }
      return err.message;
    }
  }
}
